import React, { useMemo, useState } from "react";

const Projects = ({ projectList }) => {
  const tabs = useMemo(() => ["All", ...(projectList?.heading || [])], [projectList]);
  const [activeTab, setActiveTab] = useState("All");

  const projects = useMemo(() => {
    if (!projectList?.details) {
      return [];
    }

    const allProjects = projectList.details.flatMap((group) =>
      group.project.map((item) => ({
        ...item,
        category: group.title,
      }))
    );

    return activeTab === "All"
      ? allProjects
      : allProjects.filter((item) => item.category === activeTab);
  }, [activeTab, projectList]);

  return (
    <section
      id="my_projects_list"
      className="rounded-[2rem] border border-white/15 bg-white/10 p-6 shadow-glass backdrop-blur-xl md:p-8"
    >
      <div className="mb-8 flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <p className="mb-3 text-xs font-semibold uppercase tracking-[0.32em] text-skin-accentSoft">
            Selected Work
          </p>
          <h2 className="font-display text-3xl font-bold text-skin-text md:text-4xl">
            Product builds across web, mobile, and immersive experiences
          </h2>
        </div>
        <p className="max-w-2xl text-sm leading-7 text-skin-muted">
          Filter by stack and open the projects directly. The layout is now
          simpler and faster to scan on both desktop and mobile.
        </p>
      </div>

      <div className="mb-8 flex flex-wrap gap-3">
        {tabs.map((tab) => (
          <button
            key={tab}
            type="button"
            className={`rounded-full px-5 py-3 text-sm font-medium transition ${
              activeTab === tab
                ? "bg-[var(--accent)] text-white shadow-lg shadow-[var(--accent-glow)]"
                : "border border-white/15 bg-white/10 text-skin-text hover:bg-white/15"
            }`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="grid gap-5 md:grid-cols-2 xl:grid-cols-3">
        {projects.map((project) => (
          <article
            key={`${project.category}-${project.key}`}
            className="group overflow-hidden rounded-[1.75rem] border border-white/15 bg-black/10 shadow-glass"
          >
            <div className="relative overflow-hidden">
              <img
                src={project.image}
                alt={project.title}
                className="h-52 w-full object-cover transition duration-500 group-hover:scale-105"
              />
              <span className="absolute left-4 top-4 rounded-full bg-black/45 px-3 py-1 text-xs font-semibold uppercase tracking-[0.24em] text-white backdrop-blur-xl">
                {project.category}
              </span>
            </div>
            <div className="p-6">
              <h3 className="font-display text-2xl font-semibold text-skin-text">
                {project.title}
              </h3>
              <p className="mt-3 text-sm leading-7 text-skin-muted">
                {project.description}
              </p>
              <a
                href={project.url}
                target="_blank"
                rel="noreferrer"
                className="mt-5 inline-flex items-center gap-2 text-sm font-semibold text-skin-accentSoft transition hover:text-skin-text"
              >
                Open Project <span aria-hidden="true">↗</span>
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Projects;
